import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  getJobPostsById,
  deleteJobPost,
  acceptApplication,
  declineApplication,
  removeApplicant,
} from "../../actions/job";

import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import JobApplicationPost from "../layout/Employers/JobApplicationPost";
import ApplicantItem from "../layout/Employers/ApplicantItem";
import ResumeItem from "../layout/Employers/ResumeItem";
import ApplicantResume from "../layout/Employers/ApplicantResume";
import AcceptApplicant from "../layout/Employers/AcceptApplicant";
import DeclineApplicant from "../layout/Employers/DeclineApplicant";
import CloseJobPost from "../layout/Employers/CloseJobPost";
import DeclineAcceptedApplicant from "../layout/Employers/DeclineAcceptedApplicant";

const ManageApplications = ({
  auth: { user },
  isAuthenticated,
  match,
  job: { jobs, applicants, accepted_applicants, jobloading },
  getJobPostsById,
  deleteJobPost,
  acceptApplication,
  declineApplication,
  removeApplicant,
}) => {
  const [JobApplication, setJobApplication] = useState({
    id: "",
    channelid: "",
    jobtitle: "",
    location: "",
    employmenttype: "",
    applicants: [],
    acceptedapplicants: [],
  });
  const [applicantResume, setApplicantResume] = useState({
    email: "",
    avatar: "",
    firstname: "",
    lastname: "",
    jobtitle: "",
    location: "",
    professionalsummary: "",
    experience: [],
    education: [],
    skills: [],
    imeapplicant: false,
    imeresume: false,
    resumePath: "",
    documentType: "",
  });
  const [currentApplicant, setCurrentApplicant] = useState({
    email: applicants[0],
  });
  const [showMessages, setShowMessages] = useState(false);
  const [showResume, setShowResume] = useState(false);
  const [download, setDownload] = useState(false);
  const [closeJobPost, setCloseJobPost] = useState(false);
  const [declineAcceptedApplicant, setDeclineAcceptedApplicant] =
    useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [acceptApplicant, setAcceptApplicant] = useState({
    request: false,
    confirm: false,
  });
  const [declineApplicant, setDeclineApplicant] = useState({
    request: false,
    confirm: false,
  });

  useEffect(() => {
    getJobPostsById(match.params.channelid);
  }, [getJobPostsById]);

  useEffect(() => {
    if (applicants.length > 0) {
      setCurrentApplicant({
        email: applicants[currentIndex].email,
      });
    } else {
      setCurrentApplicant({ email: "" });
    }
  }, [currentIndex]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.role === "innovator") {
    return <Redirect to="/" />;
  }

  const nextResume = () => {
    setCurrentIndex(
      currentIndex === applicants.length - 1 ? 0 : currentIndex + 1
    );
  };

  const previousResume = () => {
    setCurrentIndex(
      currentIndex === 0 ? applicants.length - 1 : currentIndex - 1
    );
  };

  return (
    <Fragment>
      <LoggedInNavBlue />
      {acceptApplicant.request && (
        <AcceptApplicant
          user={user}
          setAcceptApplicant={setAcceptApplicant}
          JobApplication={JobApplication}
          currentIndex={currentIndex}
          acceptApplication={acceptApplication}
        />
      )}
      {closeJobPost && (
        <CloseJobPost
          user={user}
          setCloseJobPost={setCloseJobPost}
          deleteJobPost={deleteJobPost}
          JobApplication={JobApplication}
        />
      )}
      {declineApplicant.request && (
        <DeclineApplicant
          user={user}
          setDeclineApplicant={setDeclineApplicant}
          JobApplication={JobApplication}
          currentApplicant={currentApplicant}
          declineApplication={declineApplication}
        />
      )}
      {declineAcceptedApplicant && (
        <DeclineAcceptedApplicant
          user={user}
          setDeclineApplicant={setDeclineApplicant}
          applicantResume={applicantResume}
          JobApplication={JobApplication}
          setDeclineAcceptedApplicant={setDeclineAcceptedApplicant}
          removeApplicant={removeApplicant}
        />
      )}
      {showResume && (
        <ApplicantResume
          setShowResume={setShowResume}
          applicantResume={applicantResume}
          download={download}
          setDownload={setDownload}
        />
      )}
      {showMessages && (
        <div class="messages-overlay">
          <div class="messages-box-alt">
            <i
              class="fas fa-times fa-3x message-x"
              onClick={() => setShowMessages(false)}
            ></i>
            <div class="message-user">
              <div className="sub-user">
                <div className="online-avi-container">
                  <div className="avi-color-border-alt green">
                    <img
                      src={
                        "https://ime.sfo3.cdn.digitaloceanspaces.com/img/user-avi-three.jpg"
                      }
                      className="sub-avi"
                      alt="avi-two"
                    />
                  </div>
                </div>
                <div className="sub-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="name-font bold green">
                        firstname lastname
                      </span>
                    </li>
                    <li className="user-online-item">jobtitle</li>
                    <li className="user-online-item">location</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="conversation-container-alt">
              <div class="conversation-message-container">
                <div class="sent-message">
                  <div class="conversation-avi-container">
                    <div class="avi-color-border blue">
                      <div class="conversation-avi"></div>
                    </div>
                  </div>
                  <div class="conversation-text-container">
                    <p class="conversation-text blue-border">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Qui eaque quos fugit repudiandae deserunt dolorem dolorum
                      similique cupiditate quibusdam non!
                    </p>
                    <div class="message-date-container blue bold">
                      <i class="far fa-clock message-date"></i>
                      Date
                    </div>
                  </div>
                </div>
              </div>
              <div class="conversation-message-container">
                <div class="received-message">
                  <div class="conversation-avi-container">
                    <div class="avi-color-border green">
                      <div class="conversation-avi"></div>
                    </div>
                  </div>
                  <div class="conversation-text-container">
                    <p class="conversation-text green-border">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Qui eaque quos fugit repudiandae deserunt dolorem dolorum
                      similique cupiditate quibusdam non!
                    </p>
                    <div class="message-date-container green bold">
                      <i class="far fa-clock message-date"></i>
                      Date
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="create-message-container">
              <input
                className="applicant-message-input"
                name="message"
                placeholder="Enter Message"
              />
              <button class="applicant-message-button background-blue">
                <i class="fas fa-paper-plane"></i>
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex-only-even-alt">
        <div className="side-container border-right grey">
          <div className="online-title-container-alt">
            <div className="border-alt blue">
              <p className="online-title-alt blue">Open Job Posts</p>
            </div>
          </div>
          <div className="job-posts">
            {jobs &&
              jobs.isArray &&
              jobs.map((post) => {
                if (post.channelid === user.channelid) {
                  return (
                    <JobApplicationPost
                      key={post._id}
                      post={post}
                      JobApplication={JobApplication}
                      setJobApplication={setJobApplication}
                      setCloseJobPost={setCloseJobPost}
                    />
                  );
                }
              })}
          </div>
          {jobs && jobs.length <= 0 && (
            <div className="empty-side-container">
              <p className="empty-content-alt-dark blue bold">
                No Open Job Posts
              </p>
            </div>
          )}
        </div>
        <div className="app-view">
          {applicants && applicants.length > 0 && applicants.length > 0 ? (
            <div className="app-header">
              <p className="prev" onClick={() => previousResume()}>
                {" "}
                <i className="fas fa-chevron-left mx-5"></i>Previous{" "}
              </p>
              <div className="application-job-title">
                <p className="job-post-title">
                  {JobApplication.jobtitle} Applications
                </p>
                {applicants &&
                  applicants.length === 1 &&
                  applicants.length > 0 && (
                    <p>
                      {currentIndex + 1} of {applicants && applicants.length}
                    </p>
                  )}
              </div>
              <p className="next" onClick={() => nextResume()}>
                {" "}
                Next<i className="fas fa-chevron-right mx-5"></i>{" "}
              </p>
            </div>
          ) : (
            <div className="empty-side-container">
              <p className="empty-content-alt-dark blue">
                No Pending Applicants
              </p>
            </div>
          )}
          {applicants &&
            applicants.isArray &&
            applicants.length > 0 &&
            applicants.map((resume, index) => {
              return (
                <ResumeItem
                  download={download}
                  key={resume._id}
                  resume={resume}
                  index={index}
                  currentIndex={currentIndex}
                  setDownload={setDownload}
                  setAcceptApplicant={setAcceptApplicant}
                  setDeclineApplicant={setDeclineApplicant}
                />
              );
            })}
        </div>
        <div className="side-container border-left grey">
          <div className="online-title-container-alt">
            <div className="border-alt blue">
              <p className="online-title-alt blue">Accepted Applicants</p>
            </div>
          </div>
          <div className="container-search">
            <div className="search-input-hidden">
              <input
                type="text"
                className="search-input-style-alt"
                placeholder="Search Applicants"
              />
            </div>
          </div>
          <div className="job-posts-applicants">
            {accepted_applicants &&
              accepted_applicants.isArray &&
              accepted_applicants.length > 0 &&
              accepted_applicants.map((applicant) => (
                <ApplicantItem
                  key={applicant._id}
                  applicant={applicant}
                  setShowMessages={setShowMessages}
                  setApplicantResume={setApplicantResume}
                  setShowResume={setShowResume}
                  setDeclineAcceptedApplicant={setDeclineAcceptedApplicant}
                />
              ))}
          </div>
          {accepted_applicants && accepted_applicants.length <= 0 && (
            <div className="empty-side-container">
              <p className="empty-content-alt-dark blue bold">
                No Accepted Applicants
              </p>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

ManageApplications.propTypes = {
  getJobPostsById: PropTypes.func.isRequired,
  deleteJobPost: PropTypes.func.isRequired,
  acceptApplication: PropTypes.func.isRequired,
  declineApplication: PropTypes.func.isRequired,
  removeApplicant: PropTypes.func.isRequired,
  job: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  job: state.job,
});

export default connect(mapStateToProps, {
  getJobPostsById,
  deleteJobPost,
  acceptApplication,
  declineApplication,
  removeApplicant,
})(ManageApplications);
